import SuperRepository from '../superRepository'

export default new (class SpendCountryReplacementRuleRepository extends SuperRepository {
  baseUri() {
    return 'spend_country_replacement_rule'
  }
  deactivate = async id => this.httpClient().put(`${this.baseUri()}/${id}/deactivate`)
})()
